<template>
  <div
    class="row flex-center tableTopSelet pc-clinic-region-select"
    :class="{ 'is-disabled': disabled }"
  >
    <div class="leftname" v-if="showLeftName">{{ leftTitle }}</div>
    <div class="flex-1">
      <el-cascader
        class="region-cascader fw100"
        :model-value="modelValue"
        :options="selectTreeOptions"
        :show-all-levels="false"
        :placeholder="placeholder"
        :filter-method="areaFilter"
        filterable
        :disabled="disabled"
        :props="cascaderProps"
        clearable
        v-bind="$attrs"
        @update:model-value="onCascaderUpdate"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import { getClinicStructTree } from "@/api/base.js";
import PinyinMatch from "pinyin-match";

export default {
  name: "PcClinicRegionSelect",
  inheritAttrs: false,
  props: {
    /** 选中的区域 id，单选 */
    modelValue: {
      type: [String, Number, null],
      default: undefined,
    },
    leftTitle: {
      type: String,
      default: "区域",
    },
    placeholder: {
      type: String,
      default: "请选择区域",
    },
    showLeftName: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      selectTreeOptions: [],
    };
  },
  computed: {
    cascaderProps() {
      return {
        expandTrigger: "hover",
        emitPath: false,
        multiple: false,
        checkStrictly: true,
      };
    },
  },
  mounted() {
    this.loadTree();
  },
  methods: {
    judgeHasChildren(arr1) {
      let arr = arr1;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].hasChildren && arr[i].children.length > 0) {
          this.judgeHasChildren(arr[i].children);
        } else {
          arr[i].children = false;
        }
      }
      return arr;
    },
    loadTree() {
      getClinicStructTree().then((res) => {
        const list = res.data.data;
        this.selectTreeOptions = this.judgeHasChildren(list);
      });
    },
    areaFilter(node, val) {
      if (!val) return true;
      const label = node.label || "";
      return !!PinyinMatch.match(label, val);
    },
    onCascaderUpdate(val) {
      this.$emit("update:modelValue", val);
    },
    onChange(val) {
      this.$emit("change", { value: val });
    },
  },
};
</script>

<style scoped lang="scss">
.tableTopSelet.pc-clinic-region-select {
  font-size: 14px;
  background-color: #fff;

  &.is-disabled {
    background-color: #f5f7fa;
    .leftname {
      color: #c0c4cc;
      background-color: #fff;
    }
  }

  .leftname {
    text-align: right;
    font-size: 13px;
    line-height: 30px;
    color: #666;
    margin-right: 12px;
    background-color: #fff;
  }

  padding: 0 0 0 12px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;

  .flex-1 {
    min-width: 0;
  }

  .fw100 {
    width: 100%;
  }

  :deep(.el-cascader) {
    width: 100%;
  }

  :deep(.el-input__wrapper) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border: none;
    box-shadow: none !important;
    padding-left: 0;
    min-height: 30px;
  }

  :deep(.el-input__inner) {
    color: #333;
  }

  :deep(.el-select) {
    border: none;
  }

  :deep(.el-input) {
    border: none;
  }

  :deep(.el-radio-button__inner) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: none;
  }
}
</style>
